import React from 'react';

import { SelectionScaffold } from '../selection/components/SelectionScaffold';
import { TerminalThankYou } from '../components/TerminalThankYou';
import { resolveW2DoneCopy, type W2DoneReason } from '../components/W2Done';
import { W2_TID } from '../constants/testids';

interface W2DoneScreenProps {
  reason?: W2DoneReason;
  /** First name for the waiver screen (screen 3); sourced from the account. */
  firstName?: string;
}

/**
 * Reskinned PHQ terminal thank-you at `/e/:token/done`. Shares the selection
 * flow's `/thanks`-style full-width terminal card + waving-man image + branded
 * scaffold (B2C `Header`) — the SAME design as `SelectionDone` — while keeping
 * this screen's pinned copy + testids: `w2-done` (root) and `w2-done-message`
 * carrying `data-reason` (complete / waive / returning), which the `w2-phq` e2e
 * contract asserts on.
 *
 * The step bar is intentionally omitted (`SelectionScaffold` without `steps`):
 * the PHQ questionnaire renders the B2C step footer, not `W2SelectionStepBar`, so
 * there is no PHQ step model to show completed here — matching the "omit the step
 * bar" option for the terminal.
 *
 * Scope note: the separate selection ineligible terminal retains its compact
 * `W2Shell` card via `<W2Done />`, now with the same permanent Header logout.
 */
export const W2DoneScreen: React.FC<W2DoneScreenProps> = ({
  reason = 'complete',
  firstName,
}) => {
  const { title, body } = resolveW2DoneCopy(reason, firstName);

  return (
    <SelectionScaffold>
      <TerminalThankYou
        testids={W2_TID.done}
        headline={title}
        body={body}
        messageProps={{ 'data-reason': reason }}
      />
    </SelectionScaffold>
  );
};
